import React from 'react';
import get from 'lodash/get';
import { Box, Flex, chakra as C } from '@tapresearch/ui/components';

import Loading from 'Shared/Loading';
import CampaignSurveyResultQuestionItem from '../../../campaign/CampaignSurveyResultQuestionItem';

export const ResultsView = ({
  results,
  tapSurveyIdentifier,
  completesCount,
  resultsLoading,
}) => {
  const questionsHash = get(results, 'questions', {});
  const tapQuestions = Object.keys(questionsHash)
    .filter((key) => key.includes('tq'))
    .map((question_id) => ({
      ...questionsHash[question_id],
      id: question_id,
    }));

  if (resultsLoading) {
    return (
      <Flex align="center" justify="center" {...Styles.Panel}>
        <Loading />
      </Flex>
    );
  }

  return (
    <Box>
      {completesCount > 0 ? (
        tapQuestions.map((question, questionIndex) => {
          return (
            <CampaignSurveyResultQuestionItem
              key={question.id}
              questionsHash={questionsHash}
              question={question}
              position={questionIndex + 1}
              resultsIdentifier={tapSurveyIdentifier}
              isCampaignResults={false}
            />
          );
        })
      ) : (
        <Flex {...Styles.Panel}>
          <C.h3
            {...{ fontWeight: 'medium', fontSize: 'xl', color: 'gray.400' }}
          >
            No responses gathered yet.
          </C.h3>
        </Flex>
      )}
    </Box>
  );
};

const Styles = {
  Panel: {
    borderRadius: '8px',
    bg: 'white',
    m: '30px 0',
    p: '50px',
    textAlign: 'center',
    boxShadow: '#e1e2e5 0 0 21px -3px',
    minHeight: '300px',
    justify: 'center',
    align: 'center',
  },
};
